<template>
  <section id="principles" class="principles">
    <h1 class="principles__header">{{ $i18n.t("principles_of_apc") }}</h1>
    <div class="principles__slider">
      <Slider>
        <div
          v-for="slide in slides"
          :key="slide.headline"
          class="principles__slider-slide"
        >
          <Video
            :isFullScreen="false"
            :vimeoId="slide.vimeoId"
            class="principles__slider-slide-video"
          />
          <h2 class="principles__slider-slide-headline">
            {{ $i18n.t(slide.headline) }}
          </h2>
          <p class="principles__slider-slide-subheadline">
            {{ $i18n.t(slide.subheadline) }}
          </p>
        </div>
      </Slider>
    </div>
  <!-- <div class="content-padder">
      <DownloadButton title="downloads_apc" :downloadItems="downloadItems" />
    </div> -->
  </section>
</template>

<script>
import Slider from "@/components/Slider";
import Video from "@/components/Video";
import DownloadButton from "@/components/DownloadButton";

export default {
  components: {
    Slider,
    Video,
    DownloadButton,
  },
  data: function() {
    return {
      downloadItems: [
        {
          previewImgName: "img_pdf_preview_principles_apc",
          title: "doc_title_basic_apc",
          file: "doc_apc",
        },
      ],
    };
  },
  computed: {
    slides() {
      return [
        {
          headline: "principles_slide_1_headline",
          subheadline: "principles_slide_1_subheadline",
          vimeoId: this.$store.getters.video_priniciples1,
        },
        {
          headline: "principles_slide_2_headline",
          subheadline: "principles_slide_2_subheadline",
          vimeoId: this.$store.getters.video_priniciples2,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss";
.principles {
  &__header {
    color: $text_dark;
    background-color: #78cdd1;
    text-align: center;
    @include padding-v(30px);
    @include ts-section-headline();
  }
  &__video {
    height: 350px;
  }
  &__slider {
    background-color: #78cdd1;
    color: white;
    &-slide {
      padding: 30px 80px 50px;
      max-width: 70%;
      @include ie_or_edge() {
        width: 70%;
        max-width: inherit;
      }

      @include breakpoint(xs) {
        padding: 0 40px 30px;
      }
      @include breakpoint(s) {
        padding: 0 40px 30px;
      }

      @include flex-v(center, center);
      text-align: center;
      &-headline {
        margin-bottom: 30px;
        text-transform: uppercase;
        font-family: $font_nettoBold;
        max-width: 70%;
        @include text(40px, 48px, 0.3px);
        @include breakpoint(xs) {
          margin-bottom: 15px;
          @include text(16px, 18px, 0.12px);
        }
        @include breakpoint(s) {
          margin-bottom: 20px;
          @include text(20px, 24px, 0.16px);
        }
      }
      &-subheadline {
        font-family: $font_nettoRegular;
        @include text(30px, 44px, 0.3px);
        max-width: 70%;
        @include breakpoint(xs) {
          @include text(12px, 18px, 0.12px);
        }
        @include breakpoint(s) {
          @include text(16px, 24px, 0.16px);
        }
      }
      &-video {
        height: 42vw;
        width: 70vw;
        margin-bottom: 40px;
      }
    }
  }
}
</style>
